import http from "@/plugins/axios";
const modalsApiCall = async (
    params,
    abortController = null,
) => {
    const { data } = await http.get('/api/company/v3/modal-windows',
        {params},
        {
            signal: abortController?.signal,
        })
    return data
}

const modalsItemApiCall = async (
    params,
    abortController = null,
) => {
    const { data } = await http.get(`/api/company/v3/modal-windows/${params.id}`,
        {
            signal: abortController?.signal,
        })
    return data
}

const createModalsItemApiCall = async (
    params,
    abortController = null,
) => {
    const { data } = await http.post(`/api/company/v3/modal-windows`,
        { ...params },
        { signal: abortController?.signal })
    return data
}

const updateModalsItemApiCall = async (
    params,
    abortController = null,
) => {
    const { data } = await http.patch(`/api/company/v3/modal-windows/${params.id}`,
        { ...params.fields },
        { signal: abortController?.signal })
    return data
}

const deleteModalsItemApiCall = async (
    params,
    abortController = null,
) => {
    const { data } = await http.delete(`/api/company/v3/modal-windows/${params.id}`,
        {
            signal: abortController?.signal,
        })
    return data
}

const stubApiCall = async (
    abortController = null,
) => {
    const { data } = await http.get('/api/company/v3/stub',
        {
            signal: abortController?.signal,
        })
    return data
}

const settingsDocsApiCall = async (
    abortController = null,
) => {
    const { data } = await http.get('/api/company/v3/sync-signed-from-nopaper',
        {
            signal: abortController?.signal,
        })
    return data
}


const createStubApiCall = async (
    params,
    abortController = null,
) => {
    const { data } = await http.post(`/api/company/v3/stub`,
        params,
        {
            signal: abortController?.signal,
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
    return data
}

const updateStubApiCall = async (
    params,
    abortController = null,
) => {
    const { data } = await http.patch(`/api/company/v3/stub`,
        { ...params },
        { signal: abortController?.signal })
    return data
}

const deleteStubApiCall = async (
    params,
    abortController = null,
) => {
    const { data } = await http.delete(`/api/company/v3/stub`,
        {
            signal: abortController?.signal,
        })
    return data
}

const updateImageStubApiCall = async (
    params,
    abortController = null,
) => {
    const { data } = await http.post(`/api/company/v3/stub/image`,
        params,
        {
            signal: abortController?.signal,
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
    return data
}


const infoPagesApiCall = async (
    abortController = null,
) => {
    const { data } = await http.get('/api/company/v3/info-pages',
        {
            signal: abortController?.signal,
        })
    return data
}

const infoPagesItemApiCall = async (
    params,
    abortController = null,
) => {
    const { data } = await http.get(`/api/company/v3/info-pages/${params.id}`,
        {
            signal: abortController?.signal,
        })
    return data
}

const createPagesItemApiCall = async (
    params,
    abortController = null,
) => {
    const { data } = await http.post(`/api/company/v3/info-pages`,
        { ...params },
        { signal: abortController?.signal })
    return data
}

const updatePagesItemApiCall = async (
    params,
    abortController = null,
) => {
    const { data } = await http.patch(`/api/company/v3/info-pages/${params.id}`,
        { ...params.fields },
        { signal: abortController?.signal })
    return data
}

const deletePagesItemApiCall = async (
    params,
    abortController = null,
) => {
    const { data } = await http.delete(`/api/company/v3/info-pages/${params.id}`,
        {
            signal: abortController?.signal,
        })
    return data
}


const hintsApiCall = async (
    abortController = null,
) => {
    const { data } = await http.get('/api/company/v3/chart-hints',
        {
            signal: abortController?.signal,
        })
    return data
}

const updateHintsItemApiCall = async (
    params,
    abortController = null,
) => {
    const { data } = await http.patch(`/api/company/v3/chart-hints`,
        { ...params },
        { signal: abortController?.signal })
    return data
}

const getServiceLinkApiCall = async (
    abortController = null,
) => {
    const { data } = await http.get('/api/company/v3/service-link',
        {
            signal: abortController?.signal,
        })
    return data
}

const updateServiceLinkApiCall = async (
    params,
    abortController = null,
) => {
    const { data } = await http.post(`/api/company/v3/service-link`,
        { ...params },
        { signal: abortController?.signal })
    return data
}


export {
    modalsApiCall,
    modalsItemApiCall,
    createModalsItemApiCall,
    updateModalsItemApiCall,
    deleteModalsItemApiCall,
    stubApiCall,
    createStubApiCall,
    updateStubApiCall,
    deleteStubApiCall,
    updateImageStubApiCall,
    infoPagesApiCall,
    infoPagesItemApiCall,
    createPagesItemApiCall,
    updatePagesItemApiCall,
    deletePagesItemApiCall,
    hintsApiCall,
    updateHintsItemApiCall,
    getServiceLinkApiCall,
    updateServiceLinkApiCall,
    settingsDocsApiCall,
}